import { journeyPostJson } from './journeyApi';

interface PitchChatStartParams {
  journey_uuid: string;
  visitor_email?: string;
  user_context?: Record<string, any>;
}

interface PitchChatMessageParams {
  journey_uuid: string;
  message: string;
  visitor_email?: string;
  user_context?: Record<string, any>;
  stream?: boolean;
}

interface PitchChatNavigateParams {
  journey_uuid: string;
  content_uuid?: string;
  node_uuid?: string;
}

interface ApiResult<T> {
  success: boolean;
  data?: T;
  error?: string;
}

export const pitchChatApi = {
  startConversation: async (params: PitchChatStartParams): Promise<ApiResult<any>> => {
    try {
      const response = await journeyPostJson('/api/pitch-chat/start', params);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('Error starting pitch chat conversation:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to start conversation',
      };
    }
  },

  sendMessage: async (params: PitchChatMessageParams): Promise<ApiResult<any>> => {
    try {
      const response = await journeyPostJson('/api/pitch-chat/message', params);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('Error sending pitch chat message:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to send message',
      };
    }
  },

  navigateContent: async (params: PitchChatNavigateParams): Promise<ApiResult<any>> => {
    try {
      const response = await journeyPostJson('/api/pitch-chat/navigate', params);
      return {
        success: true,
        data: response,
      };
    } catch (error) {
      console.error('Error navigating pitch content:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to navigate content',
      };
    }
  },
}; 